export default Object.freeze({
    DELETE: 204,
    CREATE: 201,
    OK: 200,
});
